import { atom } from 'jotai';

import { mapSettingRefsToSubscriptionIdentifiers } from '@/features/equipment-browser/subscriptions/map-to-subscription-identifiers';

import { equipmentResponseAtom } from './equipment-response.state';
import {
  getActionComponentIdentifiers,
  getDefrostScheduleIdentifiers,
  getRelatedDevicesIdentifiers,
} from './identifiers.helpers';

/**
 * settingsIdentifiersAtom
 * Maintains the computed list of subscription identifiers for settings.
 *
 * Extracts the setting identifiers from the equipment response atom
 * and maps them to the subscription identifiers.
 */
export const settingsIdentifiersAtom = atom((get) => {
  const response = get(equipmentResponseAtom);
  if (!response) return [];

  const actionComponentSettingRefs = getActionComponentIdentifiers(
    response?.actionComponents,
    true
  );

  const displaySettingRefs = response?.displaySettings?.map((setting) => setting.ref) ?? [];

  const defrostScheduleSettingRefs = getDefrostScheduleIdentifiers(
    response?.defrostScheduleConfig,
    true
  );
  const relatedDeviceSettingRefs = getRelatedDevicesIdentifiers(response?.relatedDevices, true);

  return [
    ...actionComponentSettingRefs,
    ...mapSettingRefsToSubscriptionIdentifiers(displaySettingRefs, 'displaySettings'),
    ...defrostScheduleSettingRefs,
    ...relatedDeviceSettingRefs,
  ];
});
settingsIdentifiersAtom.debugLabel = 'settingsIdentifiersAtom';
